export default {"src":"/_next/static/media/increased-vigilance.99d3b871.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};